import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogItemRef } from "./CatalogItemRef";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { CatalogItemTaxDTOBase } from "./CatalogItemTaxDTOBase";
import type { CatalogTaxRef } from "./CatalogTaxRef";
import type { CatalogTaxStaff } from "./CatalogTaxStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogItemTaxStaff implements CatalogItemTaxDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly itemId: CatalogItemStaff | null, public readonly taxId: CatalogTaxStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly itemIdTargetIds: CatalogItemRef, public readonly taxIdTargetIds: CatalogTaxRef) {
    this.cbiServiceContext = null;
    this.itemIdLoaded = this.itemId != null;
    this.itemIdCached = this.itemId;
    this.taxIdLoaded = this.taxId != null;
    this.taxIdCached = this.taxId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemIdLoaded: boolean;
  private itemIdCached: CatalogItemStaff | null;
  private taxIdLoaded: boolean;
  private taxIdCached: CatalogTaxStaff | null;
  async itemIdLazy(): Promise<CatalogItemStaff> {
    if (!this.itemIdLoaded) {
      this.itemIdCached = await this.cbiServiceContext!.catalogService().getCatalogItemStaff(this.itemIdTargetIds.assignId);
      this.itemIdLoaded = true;
    }
    return this.itemIdCached!;
  }
  async taxIdLazy(): Promise<CatalogTaxStaff> {
    if (!this.taxIdLoaded) {
      this.taxIdCached = await this.cbiServiceContext!.taxService().getCatalogTaxStaff(this.taxIdTargetIds.assignId);
      this.taxIdLoaded = true;
    }
    return this.taxIdCached!;
  }
}
